import { forwardRef } from "react";

const VARIANTS = {
  primary: "bg-su-primary text-black border-su-primary",
  success: "bg-su-success text-black border-su-success",
  secondary: "bg-su-secondary text-white border-su-secondary",
  danger: "bg-su-danger text-white border-su-danger",
  energy: "bg-su-energy text-black border-su-energy",
  ghost: "bg-transparent text-su-text border-su-border hover:border-su-primary",
};
const SIZES = {
  sm: "px-4 py-2 text-sm",
  md: "px-6 py-3 text-base",
  lg: "px-8 py-4 text-lg",
};

const Btn = forwardRef(function Btn(
  { variant = "primary", size = "md", className = "", children, ...props }, ref
) {
  return (
    <button
      ref={ref}
      className={`btn-tactile inline-flex items-center justify-center gap-2 ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
});

export default Btn;
